import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * Embed view: same tab segments as project settings ticket-type-fields
 * (`request-form`, optional empty for work item view, `workflow`).
 */
export const servicedeskGettingStartedRequestFormRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-request-form',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/request-types/request-type/:requestTypeId/:tabKey?',
	exact: true,
};
